import {
  getAndSetTenderGroups,
  updateTenderMenu,
} from 'src/home-page/business-logic/get-payment-options';
import { getValidSellableTender } from 'src/home-page/business-logic/service/get-valid-sellable-tenders';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import XLRLogger from '../common/helpers/logger';

export const getTenderMenu = async (): Promise<void> => {
  const tenders = getCurrentXLRConfig().dynamicTender
    ? []
    : await getValidSellableTender().catch(err => {
        XLRLogger.error({
          message: 'Failed to get valid tenders',
          data: err,
          source: 'get-tender-menu.ts',
        });
        return [];
      });

  const sellableTenders = {
    tenderGroups: [],
    rawTenders: tenders,
  };

  return getAndSetTenderGroups(sellableTenders)
    .then(updateTenderMenu)
    .catch(err => {
      XLRLogger.error({
        message: 'Failed to get tender menu',
        data: err,
        source: 'get-tender-menu.ts',
      });
    });
};
